import React, {Component} from 'react';
import {Link, Redirect, withRouter} from 'react-router-dom';
import db from "../dbconn";
import {API_ROOT, IMAGE_ROOT} from "../api-config";
import fetch from "isomorphic-fetch";
import Modal from 'react-responsive-modal';
import Notifications, {notify} from "react-notify-toast";
import {withTranslation} from 'react-i18next';
import i18n from '../i18n';

var parse = require('html-react-parser');

class rewards extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            redirect: false,
            homeredirect: false,
            windowHeight: 0,
            open: false,
            nosessionredirect: false,
            loyaltyPoints: "0 " + i18n.t('points'),
            expiryDate: "",
            productList: [],
            productDetailFlag:false

        };
    };

    onOpenModal = () => {
        this.setState({open: true});

    };
    onCloseModal = () => {
        this.setState({open: false});
    };

    componentWillMount() {
        if(!localStorage.getItem("store_language")){
            localStorage.setItem("store_language","en")
        }
        i18n.changeLanguage(localStorage.getItem("store_language")).then(r => {
        });

        this.fetchMenu();


    };

    fetchMenu = () => {
        var dbconn = new db();

        dbconn.getAll().then(data => {

            if (!data || data.length < 1 || sessionStorage.getItem('guestFlag') == 'Y') {
                this.setState({nosessionredirect: true});
            } else {
                var customer_id = data[0].customer_id;
                var customer_token = data[0].customer_token;
                var loyaltyProductUrl = API_ROOT + '/fetchloyaltymenu?customer_id=' + customer_id + '&customer_token=' + customer_token + '&store_id=' + localStorage.getItem('store_id');


                this.onOpenModal();

                fetch(loyaltyProductUrl)
                    .then(response => {
                        return response.json();
                    })
                    .then(data => {

                        this.onCloseModal();
                        if (data.status == 1) {

                            dbconn.getAllOrder().then(cartList => {

                                var cartLoyaltyPoints = 0;
                                for (var i = 0; i < cartList.length; i++) {

                                    if (cartList[i].product_loyalty_enabled == "Y") {
                                        cartLoyaltyPoints += (parseInt(cartList[i].product_quantity) * parseInt(cartList[i].product_loyalty_price));
                                    }
                                }


                                this.setState({loyaltyPoints: (parseInt(data.data) - cartLoyaltyPoints) + " " + i18n.t('points')});
                                if (data.expirydate != "") {
                                    this.setState({expiryDate: i18n.t('points_expire') + data.expirydate});
                                }
                                this.setState({productList: data.product_data});
                                //this.setState({productList: menuData.product_data});
                            });
                        }
                    });
            }
        });

    }

    componentDidMount() {


        document.title = "My Rewards - " + localStorage.getItem("store_name") + " - Order Anywhere";
        var primaryColor = localStorage.getItem("store_primary_color");

        if (primaryColor != null) {
            document.documentElement.style.setProperty('--primaryColor', primaryColor);
        }
        var secondaryColor = localStorage.getItem("store_secondary_color");


        if (secondaryColor != null) {
            document.documentElement.style.setProperty('--secondaryColor', secondaryColor);
        }
        var lightColor = localStorage.getItem("store_light_color");

        if (lightColor != null) {
            document.documentElement.style.setProperty('--lightColor', lightColor);
        }
        var buttonColor = localStorage.getItem("store_button_color");

        if (buttonColor != null) {
            document.documentElement.style.setProperty('--buttonColor', buttonColor);
        }


    };

    goToProduct = (product_id, position) => {

        //alert(this.state.displayList[position].modifier_count + " " + this.state.displayList[position].product_notes_enabled == "Y");
        if (this.state.productList[position].modifier_count > 0 || this.state.productList[position].product_notes_enabled == "Y") {

            this.setState({productDetailFlag: true});


            sessionStorage.setItem("product_id", product_id);
            sessionStorage.setItem("type", "A");
            sessionStorage.setItem("loyalty", "Y");
            sessionStorage.setItem("quantity", 1);
        } else {

            var dbconn = new db();

            this.state.productList[position].product_modifiers = [];
            this.state.productList[position].product_notes = "";
            this.state.productList[position].product_loyalty_enabled = "Y";

            this.addProductToCart(this.state.productList[position], 1);
        }


    };

    addProductToCart = (product, quantity) => {

        var dbconn = new db();
        var cartLength = 0;

        dbconn.getAllOrder().then(products => {

            var flag = false;
            var cartItem = 0;

            dbconn.getAllKeys().then(keys => {

                if (keys.length == 0) {
                    cartLength = 0;
                } else {
                    cartLength = Math.max(...keys);
                }


                products.map((item, index) => {

                    //  alert((parseInt(item.product_id) == parseInt(product.product_id)) + " A" + item.product_notes + " B" + product.product_notes + " C" + (item.product_notes == product.product_notes));
                    if ((parseInt(item.product_id) == parseInt(product.product_id)) && (item.product_notes == product.product_notes) && (item.product_loyalty_enabled == product.product_loyalty_enabled)) {

                        if (item.product_modifiers.length == product.product_modifiers.length) {

                            var counter = 0;
                            var selectedMod = product.product_modifiers;

                            for (var i = 0; i < selectedMod.length; i++) {

                                for (var j = 0; j < item.product_modifiers.length; j++) {

                                    if (parseInt(selectedMod[i].option_id) == parseInt(item.product_modifiers[j].option_id)) {
                                        counter++;
                                    }
                                }
                            }

                            if (counter == selectedMod.length) {

                                flag = true;
                                cartItem = item;
                            }
                        }
                    }
                });


                if (flag) {

                    //increase quantity
                    dbconn.deleteOrder(parseInt(cartItem.cart_id)).then(data => {

                        console.log(JSON.stringify({
                            product_name: cartItem.product_name,
                            product_desc: cartItem.product_desc,
                            product_name_es: cartItem.product_name_es,
                            product_desc_es: cartItem.product_desc_es,
                            product_id: cartItem.product_id,
                            product_img: cartItem.product_img,
                            product_quantity: parseInt(quantity) + parseInt(cartItem.product_quantity),
                            product_notes: "",
                            product_price: cartItem.product_price,
                            product_discount: 0,
                            product_discount_type: "",
                            product_modifiers: cartItem.product_modifiers,
                            product_loyalty_enabled: cartItem.product_loyalty_enabled,
                            product_loyalty_price: cartItem.product_loyalty_price,
                            mod_price: cartItem.mod_price,
                            isModifierAvailable: false,
                            cart_id: cartItem.cart_id
                        }));
                        dbconn.setOrder({
                            product_name: cartItem.product_name,
                            product_desc: cartItem.product_desc,
                            product_name_es: cartItem.product_name_es,
                            product_desc_es: cartItem.product_desc_es,
                            product_id: cartItem.product_id,
                            product_img: cartItem.product_img,
                            product_quantity: parseInt(quantity) + parseInt(cartItem.product_quantity),
                            product_notes: cartItem.product_notes,
                            product_price: cartItem.product_price,
                            product_original_price: cartItem.product_original_price,
                            product_discount: 0,
                            product_discount_type: "",
                            product_modifiers: cartItem.product_modifiers,
                            product_loyalty_enabled: cartItem.product_loyalty_enabled,
                            product_loyalty_price: cartItem.product_loyalty_price,
                            mod_price: cartItem.mod_price,
                            mod_original_price: 0,
                            isModifierAvailable: false,
                            cart_id: cartItem.cart_id
                        }, cartItem.cart_id).then(dat => {


                            let myColor = {background: '#0E1717', text: "#FFFFFF"};
                            notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);

                            this.setState({homeredirect: true});
                            this.fetchMenu();

                        });
                    });
                } else {


                    // alert(price);
                    console.log(JSON.stringify({
                        product_name: product.product_name,
                        product_desc: product.product_description,
                        product_name_es: product.product_name_es,
                        product_desc_es: product.product_description_es,
                        product_id: product.product_id,
                        product_img: product.product_image,
                        product_quantity: quantity,
                        product_notes: product.product_notes,
                        product_price: product.product_price,
                        product_discount: 0,
                        product_discount_type: "",
                        product_modifiers: product.product_modifiers,
                        product_loyalty_enabled: product.product_loyalty_enabled,
                        product_loyalty_price: product.product_loyalty_price,
                        mod_price: product.modifier_price,
                        isModifierAvailable: false,
                        cart_id: cartLength + 1
                    }));
                    dbconn.setOrder({
                        product_name: product.product_name,
                        product_desc: product.product_description,
                        product_name_es: product.product_name_es,
                        product_desc_es: product.product_description_es,
                        product_id: product.product_id,
                        product_img: product.product_image,
                        product_quantity: quantity,
                        product_notes: product.product_notes,
                        product_original_price: product.product_original_price,
                        product_price: product.product_price,
                        product_discount: 0,
                        product_discount_type: "",
                        product_modifiers: product.product_modifiers,
                        product_loyalty_enabled: product.product_loyalty_enabled,
                        product_loyalty_price: product.product_loyalty_price,
                        mod_price: product.modifier_price,
                        mod_original_price:0,
                        isModifierAvailable: false,
                        cart_id: cartLength + 1
                    }, cartLength + 1).then(dat => {


                        let myColor = {background: '#0E1717', text: "#FFFFFF"};
                        notify.show(i18n.t('item_added_cart'), "custom", 2000, myColor);
                        this.setState({homeredirect: true});
                        this.fetchMenu();

                    });

                }
            });
        });
    };


    render() {
        const {t} = this.props;
        const {open} = this.state;

        if (this.state.nosessionredirect) {
            return (<Redirect to={'/'}/>);
        }
        if (this.state.productDetailFlag) {
            return (<Redirect to={'/product/details'}/>);

        }
        /*    if (this.state.homeredirect) {
                return (<Redirect to={'/menu'}/>);
            }*/

        return (
            <div className="mainContainer">

                <header>
                    <div className="col-md-12 col-sm-12 col-xs-12 previous-link">
                        <Link to={'/menu'}></Link>
                        <h2 className="text-center">{t('my_rewards')}</h2>
                    </div>
                </header>
                <div className="clearfix"></div>

                <div className="m-t-30 pos-relative m-plr-10" style={{top: "45px", position: "relative"}}>
                    <div
                        className="points_box simple-box account-box bkg-grey m-t-0 center-block center-text-div m-w-60 p-0">
                        <div className="title_points"><h4 className="text-center m-0">{t('my_points')}</h4></div>
                        <h3>{this.state.loyaltyPoints}</h3>
                        <small className="font-family-bold">{this.state.expiryDate}</small>
                    </div>
                    {(this.state.productList.length > 0) ?
                        <div className="simple-box account-box bkg-grey m-t-0 p-0 m-b-0 m-w-60">
                            <h4 className="text-left text-capitalize h4-hr">{t('available_rewards')}</h4></div> : ""}

                    {(this.state.productList.length > 0) ?
                        <div className="simple-box account-box m-b-10 rewards_box m-w-60" id="productList">


                            {this.state.productList.map((item, index) => {


                                var productWidth = "";

                                /*  if (item.product_image != "") {*/
                                productWidth = "col-md-9 col-sm-9 col-xs-9";
                                /*} else {
                                    productWidth = "col-md-12 col-sm-12 col-xs-12";
                                }*/


                                return (


                                    <div key={item.product_id} className="product-block m-0 img-overlay">
                                        <div className="plr-15">

                                            <div className="col-md-3 col-sm-3 col-xs-3">
                                                <div className="row">
                                                    <div className="product-img">
                                                        {(item.product_image != "") ?
                                                            <img id={'product_image_' + item.product_id}
                                                                 src={IMAGE_ROOT + "/images/product/" + item.product_image}
                                                                 alt="Product Image"/>
                                                            :
                                                            (parseFloat(this.state.loyaltyPoints) < parseFloat(item.product_loyalty_price) != "") ?
                                                                <img id={'product_image_' + item.product_id}
                                                                     src={IMAGE_ROOT + "/img/empty.png"}
                                                                     alt="Product Image"/> : ""}
                                                        {(parseFloat(this.state.loyaltyPoints) < parseFloat(item.product_loyalty_price) != "") ?
                                                            <div className="overlay-img"></div> :
                                                            ""}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={productWidth}>
                                                <div className="row">
                                                    <div className="product-info rewards_info float_l w-100">
                                                        <div className="col-md-9 col-sm-9 col-xs-9 p-lr-15 float_l">
                                                            <h4 className="m-b-0"
                                                                id={'product_name_' + item.product_id}> {(localStorage.getItem("store_language")==="en")?item.product_name:(item["product_name_"+localStorage.getItem("store_language")]!=="")?item["product_name_"+localStorage.getItem("store_language")]:item.product_name} </h4>
                                                            <p className="rewards_h5">{parseInt(item.product_loyalty_price)} {t('points')}</p>
                                                        </div>
                                                        <div className="col-md-3 col-sm-3 col-xs-3 m-t-8 float_r">
                                                            {(parseFloat(this.state.loyaltyPoints) >= parseFloat(item.product_loyalty_price) != "") ?
                                                                <div className="row">
                                                                    <a href="#" onClick={() => {
                                                                        this.goToProduct(item.product_id, index)
                                                                    }}>{t('redeem')} ></a>
                                                                </div>
                                                                : <div className="row">
                                                                    <a href="#"
                                                                       style={{color: "#e8e8e8"}}> {t('redeem')} ></a>
                                                                </div>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>);
                            })}


                        </div> : ""}
                </div>


                <Modal closeOnEsc={false} closeOnOverlayClick={false} showCloseIcon={false}
                       open={open}
                       onClose={this.onCloseModal} center>
                    <h2>&nbsp;&nbsp;&nbsp;&nbsp;{t('loading')}...&nbsp;&nbsp;&nbsp;&nbsp;</h2>

                    <p style={{textAlign: 'center'}}>
                        <img width={'40'} height={'40'} src={'/img/loader.gif'}/>
                    </p>
                </Modal>
                <Notifications options={{zIndex: 9999, width: '100%', top: '50px'}}/>
                <div className="clearfix"></div>

            </div>
        );
    }
}

export default withRouter(withTranslation()(rewards));


// WEBPACK FOOTER //
// ./src/view_components/rewards.js